import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { PaperworkOrigin } from "web_myplann/Profile/Types/PaperworkNavigationState";

export const getPaperworkBackRoute = (origin?: PaperworkOrigin) => {
	switch (origin) {
		case PaperworkOrigin.More:
			return Routing.Profile.More.path();
		default:
			return Routing.Profile.ProfileDetail.path();
	}
};
